"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query artist($artistId: String) {
    artist(artistId: $artistId) {
      _id
      orgId
      type
      name
      genres
      socialAccounts {
        _id
        platform
        link
      }
      pressKits {
        _id
        title
        description
        posterImageUrls
        links {
          platform
          link
        }
      }
      contacts {
        _id
        firstName
        lastName
        title
        company
        email
        phoneNumber
      }
      createdAt
    }
  }
`;
exports.default = query;
//# sourceMappingURL=artist.query.js.map